import { render, staticRenderFns } from "./listing-box-details.vue?vue&type=template&id=2ed87f36&scoped=true&"
import script from "./listing-box-details.vue?vue&type=script&lang=js&"
export * from "./listing-box-details.vue?vue&type=script&lang=js&"
import style0 from "./listing-box-details.vue?vue&type=style&index=0&id=2ed87f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed87f36",
  null
  
)

export default component.exports